/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Green_Plum_Eel_CoilInputs */

const en_green_plum_eel_coil = /** @type {(inputs: Green_Plum_Eel_CoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden (confidentiality)`)
};

const de_green_plum_eel_coil = /** @type {(inputs: Green_Plum_Eel_CoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verborgen (Vertraulichkeit)`)
};

/**
* | output |
* | --- |
* | "Hidden (confidentiality)" |
*
* @param {Green_Plum_Eel_CoilInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const green_plum_eel_coil = /** @type {((inputs?: Green_Plum_Eel_CoilInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Green_Plum_Eel_CoilInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_green_plum_eel_coil(inputs)
	return de_green_plum_eel_coil(inputs)
});